import HeaderTest from "./HeaderTest";
import Footer2 from "./Footer2";

export default function Layout4({ children }) {
  return (
    <div>
      <HeaderTest />
      {children}
      <Footer2 />
    </div>
  );
}
